import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/purchase-order/{poId}/arrival-schedules/{scheduleId}/confirm`。 */
export async function confirmArrivalSchedule(poId, scheduleId, payload = {}) {
  const { data: raw } = await request.post(
    `/srm/purchase-order/${poId}/arrival-schedules/${scheduleId}/confirm`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
